import lrLinkable from './_src/lrLinkable.vue'
lrLinkable.install = function(Vue) {
  Vue.component(lrLinkable.name, lrLinkable)
}

export default lrLinkable